module.exports = __webpack_public_path__ + "static/media/down_white.d0721234.svg";